import {
  DATE_WISE_TRANSACTION_REPORT_REQUEST,
  DATE_WISE_TRANSACTION_REPORT_SUCCESS,
  DATE_WISE_TRANSACTION_REPORT_FAILURE,
} from "../types/date-wise-transction-report-types";

const initialState = {
  dateWiseTransactionReport: {},
  loading: false,
  error: null,
};

const dateWiseTransactionReportReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATE_WISE_TRANSACTION_REPORT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case DATE_WISE_TRANSACTION_REPORT_SUCCESS: {
      return {
        ...state,
        dateWiseTransactionReport: {...(action.payload || {})},
        loading: false,
        error: null
      };
    }
    case DATE_WISE_TRANSACTION_REPORT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      };
    }
    default:
      return state;
  }
};

export default dateWiseTransactionReportReducer;
